import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThmeProvider } from './context/ThemeContext';

import './App.css';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ResendOTP from './component/common/ResendOTP';
import JobPost from './pages/JobPost';
import JobPage from './pages/JobPage';
import BidPage from './pages/BidPage';
import ProfilePage from './pages/ProfilePage';
import BiddersFilter from './pages/customerpage/BiddersFilter';
import ActiveJobPage from './pages/customerpage/ActiveJobPage';
import PastJobPage from './pages/customerpage/PastJobPage';
import NotificationPage from './pages/customerpage/NotificationPage';
import CustomerProfile from './pages/customerpage/CustomerProfile';
import FundiHome from './pages/fundi/FundiHome';
import AppliedJob from './pages/fundi/AppliedJob';
import FundiActiveJobPage from './pages/fundi/FundiActiveJobPage';
import JobDetailsPage from './pages/fundi/JobDetailsPage';
import FundiPastJob from './pages/fundi/FundiPastJob';
import PackagePlansPage from './pages/fundi/PackagePlansPage';
import FundiProfile from './pages/fundi/FundiProfile';
import Customer from './pages/Customer';
import ChatPage from './pages/ChatPage';



function App() {


  return (
    <>
      <ThmeProvider>
        <Routes>
          <Route path={`/`} element={<Home />} />
          <Route path={`/customer`} element={<Customer/>} />
          <Route path={`/login`} element={<Login />} />
          <Route path={`/signup`} element={<SignUp />} />
          <Route path={`/resend-otp`} element={<ResendOTP />} />
          <Route path={`/job`} element={<JobPost/>} />
          <Route path={`/job-post`} element={<JobPage />} />
          <Route path={`/bid`} element={<BidPage />} />
          <Route path={`/profile`} element={<ProfilePage />} />
          <Route path={`/active-job`} element={<ActiveJobPage />} />
          <Route path={`/past-job`} element={<PastJobPage/>} />
          <Route path={`/notification`} element={<NotificationPage />} />
          <Route path={`/customer-profile`} element={<CustomerProfile />} />
          <Route path={`/bidders`} element={<BiddersFilter />} />
          <Route path={`/chat`} element={<ChatPage/>} />
          

          {/* Fundi routes */}
          <Route path={`/fundi`} element={<FundiHome />} />
          <Route path={`/fundi-applied-job`} element={<AppliedJob/>} />
          <Route path={`/fundi-active-job`} element={<FundiActiveJobPage />} />
          <Route path={`/fundi-job-details`} element={<JobDetailsPage />} />
          <Route path={`/fundi-past-job`} element={<FundiPastJob/>} />
          <Route path={`/fundi-plan`} element={<PackagePlansPage/>} />
          <Route path={`/fundi-profile`} element={<FundiProfile/>} />
          
        </Routes>
      </ThmeProvider>
    </>
  );
}

export default App;
